import NextImage from 'next/legacy/image'
import type { FunctionComponent, ReactNode } from 'react'
import { InternalLink } from '../../const/Links'
import { useTranslate } from '../../contexts/TranslationContext'
import type { BrandVisualResult } from '../../data/BrandFragment'
import { BrandCard } from './BrandCard'
import { Button } from './Button'
import style from './ProductEmptyState.module.sass'

type ProductEmptyStateProps = {
	favouriteBrands?: BrandVisualResult[]
	title: ReactNode
	subtitle: string | JSX.Element
}

export const ProductEmptyState: FunctionComponent<ProductEmptyStateProps> = ({ favouriteBrands, title, subtitle }) => {
	const translate = useTranslate()

	return (
		<div className={style.root}>
			<div className={style.rootContent}>
				<div className={style.rootBody}>
					<div className={style.rootTitle}>{title}</div>
					<div className={style.rootText}>{subtitle}</div>
				</div>
				<div className={style.imageWrapper}>
					<NextImage
						src="/images/empty-bowl.png"
						alt={translate('productEmptyState.alt.image')}
						title={translate('productEmptyState.alt.image')}
						layout="fill"
						objectFit="contain"
					/>
				</div>
			</div>
			{favouriteBrands && favouriteBrands.length > 0 && (
				<div className={style.brandGroupWrapper}>
					<div className={style.brandButtonWrapper}>
						<Button
							type={{ variant: 'underlinedGrey' }}
							label={translate('favouriteBrands.button.more')}
							url={InternalLink.Brands}
						/>
					</div>
					<div className={style.brandGroup}>
						{favouriteBrands &&
							favouriteBrands.length > 0 &&
							favouriteBrands.map((brand) => <BrandCard key={brand?.id} brand={brand} />).slice(0, 7)}
					</div>
				</div>
			)}
		</div>
	)
}
